import { useAccountStore } from "@/composables/account/useAccountStore";
import { goSolidApi } from "@/composables/useGoSolidApi";
import type { ManagingAccountResponse } from "@/types";
import type { AxiosResponse } from "axios";

/** Manages a client account: the server answers as that account from now on, in every tab. */
export const manageAccount = (accountId: number): Promise<void> =>
  switchManaged(
    goSolidApi.post<ManagingAccountResponse>(
      `/api/admin/accounts/manage/${accountId}`
    )
  );

/** Manages the company's owner account. The backend picks which account that is — rejects when the company has none. */
export const manageCompany = (companyId: number): Promise<void> =>
  switchManaged(
    goSolidApi.post<ManagingAccountResponse>(
      `/api/admin/accounts/manage-company/${companyId}`
    )
  );

/** Returns the session to the admin's own account. */
export const stopManaging = (): Promise<void> =>
  switchManaged(
    goSolidApi.delete<ManagingAccountResponse>("/api/admin/accounts/manage")
  );

async function switchManaged(
  answer: Promise<AxiosResponse<ManagingAccountResponse>>
): Promise<void> {
  useAccountStore().applyManagingAccount((await answer).data);
}
